import { z } from 'zod'

import { ACTION_KEYS, VIEW_HEADER_BUTTONS, VIEW_PRESET_KEYS, VIEW_PRESET_LABEL_VALUES } from '@/lib/views/presets'

export const ViewSortSchema = z.object({
  column: z.string().min(1),
  direction: z.enum(['ascending', 'descending']),
}).strict()

export const ViewPresetSchema = z.object({
  key: z.enum(VIEW_PRESET_KEYS),
  label: z.enum(VIEW_PRESET_LABEL_VALUES),
  grain: z.enum(['inventory', 'order']),
  columns: z.array(z.string().min(1)),
  sort: ViewSortSchema,
  filters: z.record(z.string(), z.string()),
  actions: z.array(z.enum(ACTION_KEYS)),
  headerButtons: z.array(z.enum(VIEW_HEADER_BUTTONS)).default([]),
}).strict()

export const ViewPresetListSchema = z.object({
  presets: z.array(ViewPresetSchema),
}).strict()

export type ViewPresetResponse = z.infer<typeof ViewPresetSchema>
export type ViewSort = z.infer<typeof ViewSortSchema>
